<template>
<div>
     <span class="infocontainer">
    <b-button :id="ID" class="infobutton" href="#" tabindex="0">
      <font-awesome-icon
        class="fa-1x infoicon align-middle text-info"
        :icon="['fas','info-circle']"
      />
    </b-button>
    <b-popover :target="ID" placement="right" triggers="click blur">
      <h6>Following file types are supported</h6>
      <div class="list-group">
        {{fileTypes}}
      </div>
    </b-popover>
  </span>
</div>
</template>
<script>
export default {
  name: "FileUploadInfo",
  data() {
    return {
      ID: `infoButton-${this.generateRandomIdForElement()}`,
      fileTypes: this.supportedFileTypesForWalletRequest(),
    };
  },
  methods: {
    generateRandomIdForElement() {
      return (
        Date.now().toString(36) + Math.random().toString(36).substr(2, 5)
      ).toUpperCase();
    },
  },
};
</script>
<style scoped>
.infocontainer {
  padding: 0 0 0px 5px !important;
  display: inline-block;
}
</style>
